module.exports = __webpack_public_path__ + "img/airfloss2.08eb2bc8.jpg";